import { motion } from "framer-motion";
import { imgSrc } from "@/lib/api";

export function PageHero({ eyebrow, title, sub, image }) {
  return (
    <section className={`relative overflow-hidden ${image ? "bg-slate-950 text-white" : "bg-cream text-ink"}`} data-testid="page-hero">
      {image && (
        <>
          <img src={imgSrc(image)} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/70 to-slate-950/40" />
        </>
      )}
      <div className="relative container-site py-14 sm:py-16">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          {eyebrow && <p className="label-eyebrow mb-4">{eyebrow}</p>}
          <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight leading-[1.0] max-w-3xl">
            {title}
          </h1>
          {sub && <p className={`mt-5 max-w-xl text-sm sm:text-base leading-relaxed ${image ? "text-white/80" : "text-slate-600"}`}>{sub}</p>}
        </motion.div>
      </div>
    </section>
  );
}
